import { villageListApi } from "../../api/village/villageListApi"
import { Village } from "../../entities/village"

type PayloadShape = Parameters<typeof villageListApi>[0]

export async function villageListService(payload: PayloadShape, token?: null | string) {
	const village = await villageListApi(payload, token)
	return village as NonNullable<Village[]>
}
